import {DataGridPro} from "@mui/x-data-grid-pro";
import React, {useEffect, useState, useCallback} from "react";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import Slider from '@mui/material/Slider';
import Button from "@mui/material/Button";
import StyledBox from "../../components/StyledBox";
import server from "../../server";
import {buildUrlWithQueryParams} from "../../components/buildUrlWithQueryParams";
import {AxiosSyncDefaultRequest} from "../../components/default_request";
import LinearProgress from "@mui/material/LinearProgress";
import CustomNoRowsOverlay from "../../components/CustomNoRowsOverlay";
import ToolBar from "../../components/ToolBar";
import Typography from "@mui/material/Typography";
import Alert from "@mui/material/Alert";
import Snackbar from "@mui/material/Snackbar";
import debounce from "lodash/debounce";

const FuseManagement = "FuseManagement"

// 通用的fetch方法
const useFetch = (url, setData, setLoading, setCount, currentPage, pageSize, setSnackbarState) => {
  return async (sortData = {}) => {
    const queryParams = {
      curr_page: currentPage < 1 ? 1 : currentPage,
      page_size: pageSize,
      ...sortData
    };
    const requestUrl = buildUrlWithQueryParams(url, queryParams);
    setLoading(true);
    try {
      await AxiosSyncDefaultRequest({
        url: requestUrl,
        method: 'GET',
        success: (res) => {
          setData(res.data.rows);
          setLoading(false);
          if (setCount) setCount(res.data.total);
        },
        fail: (error) => {
          console.error('请求失败', error);
          setData([]);
          setLoading(false);
          throw error;
        }
      });
    } catch (error) {
      console.error('请求异常', error);
      setSnackbarState({
        open: true,
        message: error.message || '请求失败',
        severity: 'error'
      });
    }
  };
};

function FuseManagementPage () {
  const [snackbarState, setSnackbarState] = useState({
    open: false,
    message: '',
    severity: 'success'
  });
  const [Visibility, setVisibility] = useState({
    id: false,
  })
  const [HufFileVisibility, setHufFileVisibility] = useState({
    id: false,
  })
  const [DailyOrdersVisibility, setDailyOrdersVisibility] = useState({
    id: false,
  })
  const [pageSize, setPageSize] = useState(100);
  const [currentPage, setCurrentPage] = useState(0);
  const [hufFilePageSize, setHufFilePageSize] = useState(100);
  const [hufFileCurrentPage, setHufFileCurrentPage] = useState(0);
  const [dailyOrdersCurrentPage, setDailyOrdersCurrentPage] = useState(0);
  const [dailyOrdersPageSize, setDailyOrdersPageSize] = useState(100);
  // 进度条状态
  const [total, setTotal] = useState(null);
  const [completed, setCompleted] = useState(null);
  const [loading, setLoading] = useState(false);
  const [huf_file_loading, setHufFileLoading] = useState(false);
  const [d_loading, setDLoading] = useState(false);

  const [data, setData] = useState([]);
  const [huf_file_data, setHufFileData] = useState([]);
  // 每日打单情况
  const [daily_orders_data, setDailyOrdersData] = useState([]);
  const [searchData, SetSearchData] = useState({});
  const [huf_file_count, setHufFileCount] = useState(0);
  const [daily_orders_count, setDailyOrdersCount] = useState(0);
  const [usra_file_count, setUsraFileCount] = useState(0);
  const marks = [
    {
      value: completed,
      label: `${completed}`,
    },

    {
      value: total,
      label: `${total}`,
    },
  ];
  // 使用防抖处理刷新操作
  const debouncedFetch = useCallback(
    debounce((fetchFn) => fetchFn(), 300),
    []
  );

  const Refresh = () => {
    setData([]);
    debouncedFetch(fetchData);
  };

  const HufFileRefresh = () => {
    setHufFileData([]);
    debouncedFetch(fetchHufFileData);
  };

  const DailyOrderRefresh = () => {
    setDailyOrdersData([]);
    debouncedFetch(fetchDailyFuseStatisticsData);
  };
  const fetchData = useFetch(
    server.ursa_file,
    setData,
    setLoading,
    setUsraFileCount,
    currentPage,
    pageSize,
    setSnackbarState
  );
  const fetchHufFileData = useFetch(
    server.get_huf_file,
    setHufFileData,
    setHufFileLoading,
    setHufFileCount,
    hufFileCurrentPage,
    hufFilePageSize,
    setSnackbarState
  );
  const fetchDailyFuseStatisticsData = useFetch(
    server.daily_fuse_statistics,
    setDailyOrdersData,
    setDLoading,
    setDailyOrdersCount,
    dailyOrdersCurrentPage,
    dailyOrdersPageSize,
    setSnackbarState
  );
  const fetchTrackingPoolData = async (sortData={}, setSnackbarState) => {
    const queryParams = {
      // ...searchData, // 将搜索条件作为查询参数
      // ...sortData,
      // curr_page: dailyOrdersCurrentPage < 1 ? 1 : dailyOrdersCurrentPage,
      // page_size: dailyOrdersPageSize,
    };
    let requestUrl = server.tracking_pool_list;
    // requestUrl = buildUrlWithQueryParams(requestUrl, queryParams);
    // setDLoading(true)
    try {
      await AxiosSyncDefaultRequest({
        url: requestUrl,
        method: 'GET',
        success: (res) => {
          console.log(res.data.total)
          let Avaliable = res.data.total.Avaliable;
          let Used = res.data.total.Used;
          let Loading = res.data.total.Loading;

          if(res.data.total.Avaliable){
            Avaliable = res.data.total.Avaliable
          }
          else {
            Avaliable = 0
          }
          if(res.data.total.Used){
            console.log("Used",res.data.total.Used)
            Used = res.data.total.Used
          }
          else {
            Used = 0
          }
          let total = Avaliable + Used + Loading;
          console.log("total",total)
          setTotal(total)
          setCompleted(Used)
          // setDailyOrdersData(res.data.rows)
          // setDLoading(false);
          // setDailyOrdersCount(res.data.total)

        },
        fail: (error) => {
          console.error('请求失败', error);
          setDailyOrdersData([])
          setDLoading(false)
        }
      });
    } catch (error) {
      console.error('请求异常', error);
      setSnackbarState({
        open: true,
        message: error.message || '请求失败',
        severity: 'error'
      });
    }
  };
  useEffect(() => {
      fetchData();
      fetchHufFileData();
      fetchDailyFuseStatisticsData();
      fetchTrackingPoolData({}, setSnackbarState);

      // 设置30秒定时器自动更新Tracking Pool数据
      const timer = setInterval(() => {
        fetchTrackingPoolData({}, setSnackbarState);
      }, 10000);

      // 组件卸载时清理定时器
      return () => clearInterval(timer);
  }, [currentPage, hufFileCurrentPage]);
  const handleSortModelChange = async (sortModel) => {
    let ordering = '';
    if (sortModel.length > 0) {
      // 处理所有的排序模型，虽然通常只有一个
      ordering = sortModel.map(model => {
        return model.sort === 'asc' ? model.field : `-${model.field}`;
      }).join(',');
    }
    // 构造排序的数据结构
    const sortData = { ordering };
    // 调用 fetchData 函数请求数据
    setLoading(true);
    setData([]);
    await fetchData(sortData);
  };
  const handleHufFileSortModelChange = async (sortModel) => {
    let ordering = '';
    if (sortModel.length > 0) {
      // 处理所有的排序模型，虽然通常只有一个
      ordering = sortModel.map(model => {
        return model.sort === 'asc' ? model.field : `-${model.field}`;
      }).join(',');
    }
    // 构造排序的数据结构
    const sortData = { ordering };
    // 调用 fetchData 函数请求数据
    setLoading(true);
    setData([]);
    await fetchHufFileData(sortData);
  };
  const handleDailyFuseStatisticsSortModelChange = async (sortModel) => {
    let ordering = '';
    if (sortModel.length > 0) {
      // 处理所有的排序模型，虽然通常只有一个
      ordering = sortModel.map(model => {
        return model.sort === 'asc' ? model.field : `-${model.field}`;
      }).join(',');
    }
    // 构造排序的数据结构
    const sortData = { ordering };
    // 调用 fetchData 函数请求数据
    setLoading(true);
    setData([]);
    await fetchDailyFuseStatisticsData(sortData);
  };
  const columns = [
    { field: 'id', headerName: 'ID', width: 90 },
    {
      field: 'name',
      headerName: 'Ursa Name',
      flex: 5,
    },
    {field: 'effectiveDate', headerName: "生效日期", flex: 5},
    {field: 'expirationDate', headerName: "失效日期", flex: 5},
    {field: 'downloadDate', headerName: "下载日期", flex: 5},
    {field: 'effected', headerName: "状态", flex: 5},
    {field: 'url', headerName: "下载", flex: 3, renderCell: (params) => {
      if (params.value) {
        return (
          <Button 
            variant="text" 
            size="small" 
            onClick={() => window.open(params.value, '_blank')}
          >
            下载
          </Button>
        );
      }
      return null;
    }},
  ]
  const huf_file_columns = [
    { field: 'id', headerName: 'ID', width: 90 },
    {
      field: 'name',
      headerName: '名称',
      width: 300,
    },
    {field: 'huf_file_status', headerName: "状态", width: 50, renderCell: (params) => {
      const statusMap = {
        0: "创建HUF_FILE",
        1: "处理中",
        2: "推送失败",
        3: "成功"
      };
      return statusMap[params.value] || params.value;
    }},
    {field: 'amount', headerName: "件数", width: 20},
    {field: 'upload_timestamp', headerName: "推送时间", width: 150},
    {field: 'create_time', headerName: "创建时间", width: 150},
    {field: 'type_name', headerName: "渠道类型", width: 70},
    {field: 'sequence_number', headerName: "序号", width: 60},
    {field: 'customer_manifest_id', headerName: "清单ID", width: 100},
  ];
  const daily_orders_columns = [
    { field: 'id', headerName: 'ID', width: 90 },
    {
      field: 'fedex_carrier',
      headerName: '类型',
      flex: 5,
    },
    {field: 'total', headerName: "票数", flex: 5},
    {field: 'statistics_date', headerName: "日期", flex: 5},

  ]
  function valuetext(value) {
    return value;
  }
  return (
      <Box sx={{minWidth: '100%'}}>
      <Snackbar
        open={snackbarState.open}
        autoHideDuration={6000}
        onClose={() => setSnackbarState(prev => ({ ...prev, open: false }))}
      >
        <Alert
          onClose={() => setSnackbarState(prev => ({ ...prev, open: false }))}
          severity={snackbarState.severity}
          sx={{ width: '100%' }}
        >
          {snackbarState.message}
        </Alert>
      </Snackbar>
      <Grid container spacing={3}>
        <Grid item xs={5}>
          <StyledBox  sx={{ width: "100%", overflow: "auto", height: "400px", position: "relative" }}>
            <Typography
                variant="h6"
                sx={{
                  position: "absolute",
                  top: 8,
                  right: 16,
                  zIndex: 1,
                  backgroundColor: "rgba(255, 255, 255, 0.8)",
                  padding: "4px 8px",
                  borderRadius: "4px",
                }}
            >
              运单号码(USRA)分配文件
            </Typography>
            <DataGridPro
                columns={columns}
                rows={data}
                rowCount={usra_file_count}
                onPageChange={(page) => setCurrentPage(page)}
                onPageSizeChange={pageSize => setPageSize(pageSize)}
                pageSize={pageSize}
                rowsPerPageOptions={[25, 30, 50, 100, 200, 500]}
                columnBuffer={3}
                columnThreshold={3}
                columnVisibilityModel={Visibility}
                density="compact"
                pagination={true}
                sortingMode="server"
                autoWidth={false}
                rowReordering={false}
                loading={loading}
                onSortModelChange={handleSortModelChange}
                components={{
                  LoadingOverlay: LinearProgress,
                  NoRowsOverlay: CustomNoRowsOverlay,
                  Toolbar: () => <ToolBar onRefresh={Refresh} />,
                }}

            />
          </StyledBox>
        </Grid>
        <Grid item xs={7}>
          <StyledBox  sx={{ width: "100%", overflow: "auto", height: "400px", position: "relative" }}>
            <Typography
                variant="h6"
                sx={{
                  position: "absolute",
                  top: 8,
                  right: 16,
                  zIndex: 1,
                  backgroundColor: "rgba(255, 255, 255, 0.8)",
                  padding: "4px 8px",
                  borderRadius: "4px",
                    color: "#55b5fb",
                }}
            >
              货运使用文件(Huf File)
            </Typography>
            <DataGridPro
                columns={huf_file_columns}
                rows={huf_file_data}
                rowCount={huf_file_count}
                onPageChange={(page) => setHufFileCurrentPage(page)}
                onPageSizeChange={pageSize => setHufFilePageSize(pageSize)}
                pageSize={hufFilePageSize}
                rowsPerPageOptions={[25, 30, 50, 100, 200, 500]}
                columnBuffer={3}
                columnThreshold={3}
                columnVisibilityModel={HufFileVisibility}
                density="compact"
                pagination={true}
                sortingMode="server"
                rowReordering={false}
                loading={huf_file_loading}
                onSortModelChange={handleHufFileSortModelChange}
                components={{
                  LoadingOverlay: LinearProgress,
                  NoRowsOverlay: CustomNoRowsOverlay,
                  Toolbar: () => <ToolBar onRefresh={HufFileRefresh} />,
                }}
            />
          </StyledBox>
        </Grid>
        <Grid item xs={5}>
          <StyledBox  sx={{ width: "100%", overflow: "auto" , height: "400px", position: "relative" }}>
            <Typography
                variant="h6"
                sx={{
                  position: "absolute",
                  top: 8,
                  right: 16,
                  zIndex: 1,
                  backgroundColor: "rgba(255, 255, 255, 0.8)",
                  padding: "4px 8px",
                  borderRadius: "4px",
                    color: "#b34949",
                }}
            >
              每日打单情况
            </Typography>
            <DataGridPro
                columns={daily_orders_columns}
                rows={daily_orders_data}
                rowCount={daily_orders_count}
                onPageChange={(page) => setDailyOrdersCurrentPage(page)}
                onPageSizeChange={pageSize => setDailyOrdersPageSize(pageSize)}
                pageSize={dailyOrdersPageSize}
                rowsPerPageOptions={[25, 30, 50, 100, 200, 500]}
                columnBuffer={3}
                columnThreshold={3}
                columnVisibilityModel={DailyOrdersVisibility}
                density="compact"
                pagination={true}
                sortingMode="server"
                rowReordering={false}
                loading={d_loading}
                onSortModelChange={handleDailyFuseStatisticsSortModelChange}
                components={{
                  LoadingOverlay: LinearProgress,
                  NoRowsOverlay: CustomNoRowsOverlay,
                  Toolbar: () => <ToolBar onRefresh={DailyOrderRefresh} />,
                }}
            />
          </StyledBox>
        </Grid>
        {/*进度条 */}
        <Grid item xs={7}>
        <Box sx={{ minHeight: '400px', p: 3, bgcolor: 'background.paper', borderRadius: 2, boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.15)', border: '1px solid #e0e0e0' }}>
          <StyledBox sx={{ height: "100%", display: "flex", flexDirection: "column", gap: 2, p: 2, position: "relative" }}>
            <Typography
                variant="h6"
                sx={{
                  position: "absolute",
                  top: 8,
                  right: 16,
                  zIndex: 1,
                  backgroundColor: "rgba(255, 255, 255, 0.8)",
                  padding: "4px 8px",
                  borderRadius: "4px",
                  color: "#45c3ff",
                }}
            >
              单号使用进度
            </Typography>
              <Typography variant="body2" color="text.secondary" gutterBottom>
                已使用进度
              </Typography>
              <Slider
                  aria-label="Always visible"
                  value={completed}
                  getAriaValueText={valuetext}
                  step={10}
                  marks={marks}
                  valueLabelDisplay="off"
                  max={total}
                  sx={{
                    '& .MuiSlider-markLabel': {
                      color: 'text.secondary',
                    },
                    '& .MuiSlider-valueLabel': {
                      bgcolor: '#45c3ff',
                    }
                  }}
              />
            
          </StyledBox></Box>
        </Grid>

      </Grid>
      </Box>
  )
}
export default FuseManagement
export {FuseManagementPage}